<template>
    <b-container>
        <h1>Cart</h1>

        <b-table show-empty :fields="fields" :items="getProductsInCart">
            <template v-slot:empty="scope">
                <div class="d-block text-center">
                    <span class="d-block h2"><ion-icon name="sad-outline"></ion-icon></span>
                    <span class="d-block">You have no items in your cart.</span>
                </div>
            </template>
            <template v-slot:cell(name)="data">
                {{ data.item.itemDetails.name }} (£{{formatMoney(data.item.itemDetails.price)}})
                <div v-if="data.item.selectedModifiers.length > 0">
                    <ul class="list p-0 list-unstyled">
                        <li v-for="(modifier, index) in data.item.selectedModifiers" :key="index">
                            <span class="text-muted small">{{ modifier.name }} (£{{formatMoney(modifier.price)}})</span>
                        </li>
                    </ul>
                </div>
            </template>


            <template v-slot:cell(price)="data">
                {{ formatMoney(data.item.total) }}
            </template>

            <template v-slot:cell(action)="data">
                <div @click="removeItem(index)" class="d-flex align-items-center">
                    <ion-icon name="trash"></ion-icon> Remove
                </div>
            </template>
        </b-table>


        <div class="cart-meta-container shadow-lg">
            <p class="total">Total: £{{ formatMoney(total) }}</p>
            <b-btn @click="goToBridge" variant="primary" :disabled="getProductsInCart.length == 0">Pay</b-btn>
        </div>
    </b-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "Cart",

        data() {
            return {
                fields: [
                    {key: 'name'},
                    {key: 'price'},
                    {key: 'action'},
                ]
            }
        },

        computed: {
            ...mapGetters([
                'getProductsInCart',
            ]),

            total: function () {
                let sum = 0;
                this.getProductsInCart.forEach(function (item) {
                    sum += parseFloat(item.total);
                });
                return sum;
            }
        },

        mounted() {
            console.log(this.getProductsInCart)
        },

        methods: {
            ...mapActions([
                'removeProduct',
            ]),
            removeItem(index) {
                this.removeProduct(index);
                this.$toasted.show('Item removed from cart')
            },
            formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

            goToBridge(){
                axios.get('/settings/profile').then(response => {
                    if (response.data.staff == 1){
                      console.log(response.data.staff);
                      this.$router.push({name: 'checkoutWaiter'})
                    } else {
                      this.$router.push({name: 'checkout'});
                    }
                }).catch(error => {
                    this.$router.push({name: 'loginBridge'});
                })
            }
        }
    }
</script>

<style scoped>

</style>